export default "__VITE_ASSET__Cmm1tGG5__"